module.exports = __webpack_public_path__ + "static/media/avg-rate.ae7e3635.png";